// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyFileInput_errorMessage__Y9mtx"};